// LT-511: top bar for the public booking page. Void mark + "booking"
// accent pill on the left, muted "Powered by" tagline on the right.
import React from 'react';
import { Pill } from '../../../ui';
import { APP_NAME } from '../../../config/region';

const TopBar: React.FC = () => (
  <div className="max-w-[1120px] mx-auto mb-6 flex items-center justify-between">
    <div className="flex items-center gap-2.5">
      <div
        className="w-7 h-7 rounded-ds-lg flex items-center justify-center font-bold text-sm text-white"
        style={{ background: 'linear-gradient(135deg, var(--accent), var(--info))' }}
        aria-hidden="true"
      >
        V
      </div>
      <span className="text-[13px] font-semibold text-slate-300">Void</span>
      <Pill intent="accent" className="ml-1">booking</Pill>
    </div>
    <div className="text-xs text-slate-500">
      Powered by <span className="text-slate-400">{APP_NAME}</span>
    </div>
  </div>
);

export default TopBar;
